import ReactGA from 'react-ga4';

export const trackDemoOpen = (status: string) => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_open',
    label: status,
  });
};

export const trackDemoResetClick = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_reset_click',
  });
};

export const trackDemoResetConfirm = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_reset_confirm',
  });
};

export const trackDemoResetCancel = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_reset_cancel',
  });
};

export const trackDemoResetNoUser = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_reset_no_user',
  });
};

// intro (enter email)

export const trackDemoEnterEmailSuccess = (isNew: boolean) => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_enter_email_success',
    label: `${isNew ? 'New' : 'Existing'} user`,
  });
};

export const trackDemoEnterEmailError = (error: string) => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_enter_email_error',
    label: error,
  });
};

export const trackDemoExistingEmailModalContinue = (step: string) => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_existing_email_modal_continue',
    label: step,
  });
};
export const trackDemoExistingEmailModalUseNewEmail = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_existing_email_modal_use_new_email',
  });
};

// upload

export const trackDemoAddFile = (type: string) => {
  ReactGA.event({
    category: 'Demo',
    action: `demo_add_${type}`,
  });
};

export const trackDemoUploadFileSuccess = (type: string) => {
  ReactGA.event({
    category: 'Demo',
    action: `demo_upload_${type}_success`,
  });
};

export const trackDemoUploadFileError = (type: string, fileName: string) => {
  ReactGA.event({
    category: 'Demo',
    action: `demo_upload_${type}_error`,
    label: fileName,
  });
};

export const trackDemoBatchUploadVideoSuccess = (count: number) => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_batch_upload_video_success',
    value: count,
  });
};

// analysis

export const trackDemoAnalysisStartSuccess = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_analysis_start_success',
  });
};

export const trackDemoAnalysisStartError = (errMsg: string) => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_analysis_start_error',
    label: errMsg,
  });
};

export const trackDemoAnalysisFinish = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_analysis_finish',
  });
};

export const trackDemoAnalysisChangeClips = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_analysis_change_clips',
  });
};

// generation

export const trackDemoGenerationStartSuccess = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_generation_start_success',
  });
};

export const trackDemoGenerationStartError = (errMsg: string) => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_generation_start_error',
    label: errMsg,
  });
};

export const trackDemoGenerationFinish = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_generation_finish',
  });
};

export const trackDemoGenerationPlayCreationSuccess = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_generation_play_creation_success',
  });
};

export const trackDemoGenerationPlayCreationError = (errMsg: string) => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_generation_play_creation_error',
    label: errMsg,
  });
};

export const trackDemoGenerationClickContact = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_generation_click_contact',
  });
};

export const trackDemoGenerationDownloadSuccess = () => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_generation_download_success',
  });
};

export const trackDemoGenerationDownloadError = (errMsg: string) => {
  ReactGA.event({
    category: 'Demo',
    action: 'demo_generation_download_error',
    label: errMsg,
  });
};

// used for both analysis and generation notifications
export const trackDemoNotificationToggle = (type: string, value: boolean) => {
  ReactGA.event({
    category: 'Demo',
    action: `demo_${type}_notification_toggle`,
    label: value ? 'Enabled' : 'Disabled',
  });
};
